import { IShowResultPanelAction, ResultActionEnum, IHideResultPanelAction } from '.';
import {
    IAuction,
} from '../../services';

export const ShowResultPanelAction = (auction: IAuction) => {
  
  return {
    type: ResultActionEnum.ShowResultPanel,
    state: {
      showResultPanel: true,
      itaAuctionResult: auction.auctionResult
    },
  } as IShowResultPanelAction;
};

export const HideResultPanelAction = () => {
  return {
    type: ResultActionEnum.HideResultPanel,
    state: {
      showResultPanel: false
    },
  } as IHideResultPanelAction;
};